import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SNAPSHOTS_NAME_MAP } from 'utils/adminExperienceHelpers'
import { ADMIN_DASHBOARD_ENTRY_ID } from 'utils/entryIds'
import { findTooltipByLocation } from 'utils/tooltipHelpers'
import AdminTooltip from './component'

const AdminTooltipContainer = ({
  className,
  dataTestId,
  iconClass,
  label,
  monitorView,
  tooltipData,
}) => {
  if (!tooltipData) return null

  const Content = (
    <Fragment key={`tooltip-header-${tooltipData.tooltipHeader}`}>
      <span className="tooltip-header">{tooltipData.tooltipHeader}</span>
      <span>{tooltipData.text}</span>
    </Fragment>
  )

  return (
    <AdminTooltip
      className={className}
      content={Content}
      dataTestId={dataTestId}
      iconClass={iconClass}
      label={label}
      monitorView={monitorView}
    />
  )
}

const mapStateToProps = (
  { contentful },
  { location, panelName, programKey, snapshotSource },
) => {
  // Allow snapshotSource to override the default SNAPSHOTS_NAME_MAP lookup
  const snapshotKey = snapshotSource || SNAPSHOTS_NAME_MAP?.[programKey]
  const snapshots =
    contentful?.[ADMIN_DASHBOARD_ENTRY_ID]?.payload?.[snapshotKey]
  const tooltipData = findTooltipByLocation(
    location,
    programKey,
    snapshots,
    panelName,
  )

  return {
    tooltipData,
  }
}

AdminTooltipContainer.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  iconClass: PropTypes.string,
  label: PropTypes.string,
  location: PropTypes.string,
  monitorView: PropTypes.bool,
  programKey: PropTypes.string,
  snapshotSource: PropTypes.string,
  tooltipData: PropTypes.object,
}

export default connect(mapStateToProps, null)(AdminTooltipContainer)
